import React from 'react'
import timeAgo from './time-ago'

const TimeAgo = ({ time, flavour = 'tiny', component: Component = 'span' }) => (
  <Component>{timeAgo.format(time, { flavour }).toLocaleUpperCase()}</Component>
)

export default TimeAgo
